import { createAction } from "~/utils/actions";

export default {
	...createAction("INIT_STORE"),
};
